import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrentUserService } from '@shared/services';

@Component({
  selector: 'sign-up-success',
  templateUrl: './sign-up-success.component.html',
  styleUrls: ['./sign-up-success.component.scss']
})
export class SignUpSuccessComponent implements OnInit {
  returnUrl: string = '';

  constructor(
    public modalRef: BsModalRef,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit() {
    this.returnUrl =
      this.activatedRoute.snapshot.queryParams['returnUrl'] ||
      '/app/properties';
  }

  navigateTo() {
    this.modalRef.hide();
    const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};
    currentUser.isLogin = true;
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
    this.currentUserService.loanUserInfo().then(() => {
      this.router.navigate([this.returnUrl]);
    });
  }
}
